import * as THREE from 'three';
import { gsap, Power4 } from "gsap";
import { vPoemShader, fPoemShader } from '../shaders';
import { PoemId } from "../constants";

export class Poem {
    constructor({ assets, model }) {
        // Extract textures from the Assets class
        const { poems, noise, hatchC } = assets.textures;

        const geom = new THREE.PlaneGeometry(.5, .0625)
        const mat = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: poems },
                noiseMap: { value: noise },
                time: { value: 0 },
                brightness: { value: 1 },
                titleIndx: { value: PoemId.LIBRARY },
                opacity: { value: 0 },
                side: THREE.FrontSide,
            },
            vertexShader: vPoemShader,
            fragmentShader: fPoemShader,
            transparent: true,
        })

        this.holder = new THREE.Mesh(geom, mat);
        this.holder.scale.set(1.8, 1.8, 1.8)
        this.holder.position.set(0, 0, -.07);
        model.add(this.holder);

        this.timeoutID = null
    }

    show({ poemId, screenHeight, timeout = 0, delay = 0 }) {
        this.holder.material.uniforms.titleIndx.value = poemId;
        this.holder.position.y = -screenHeight/2 + .05;
        this.holder.position.x = 0;//-screenWidth/2;// + .25;

        this.doTweens({ opacity: 1, duration: 3, delay, z:-.14, ease: Power4.easeOut });

        if (timeout) {
            if (this.timeoutID) clearTimeout(this.timeoutID);
            this.timeoutID = setTimeout(() => this.hide(), timeout);
        }
    }

    hide() {
        this.doTweens({ duration: 1, delay:0, opacity: 0, z: -.07, ease: Power4.easeIn });
    }

    doTweens({ duration, delay, ease, opacity, z }) {
        // Kill existing tweens
        const { material, position } = this.holder;
        gsap.killTweensOf(material.uniforms.opacity);
        gsap.killTweensOf(position);

        gsap.to(material.uniforms.opacity, { delay, value: opacity, duration, ease});

        gsap.to(position, { delay, z, duration, ease });
    }

    update(time) {
        this.holder.material.uniforms.time.value = time;
    }

    get active() {
        return (this.holder && this.holder.material.uniforms.opacity.value > 0);
    }
}